export let OperationsUserGroup = /*#__PURE__*/function (OperationsUserGroup) {
  OperationsUserGroup["OperationsAdmin"] = "Operations Admin";
  OperationsUserGroup["Operations"] = "Operations";
  return OperationsUserGroup;
}({});